export default __webpack_public_path__ + "198b91c43395433fcaabdf37fae37d4b.png";